import { Reveal, SectionHead } from "./Reveal";

const SGMonogram = () => (
    <svg viewBox="0 0 120 120" className="h-44 w-44" role="img" aria-label="SG monogram for founder Sarah Gmyr">
        <circle cx="60" cy="60" r="58" fill="#0B192C" />
        <path d="M12 88c20 18 68 18 92-8" fill="none" stroke="#2DD4BF" strokeWidth="4" strokeLinecap="round" />
        <circle cx="42" cy="34" r="7" fill="#F59E0B" />
        <text x="60" y="72" textAnchor="middle" fontFamily="Archivo, sans-serif" fontWeight="900" fontSize="34" fill="#FDFBF7">
            SG
        </text>
    </svg>
);

export default function About() {
    return (
        <section id="about" className="scroll-mt-24 pb-10 sm:pb-14 lg:pb-28">
            <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
                <div>
                    <Reveal>
                        <SectionHead eyebrow="About" title="Meet Sarah" />
                    </Reveal>
                    <Reveal delay={0.1}>
                        <div className="mt-8 flex items-center gap-6">
                            <SGMonogram />
                            <div>
                                <p className="font-display text-2xl font-extrabold text-ink">Sarah Gmyr</p>
                                <p className="text-lg text-ink-soft">Founder, Fall Safe Ready</p>
                            </div>
                        </div>
                    </Reveal>
                </div>
                <div>
                    <Reveal delay={0.1}>
                        <p className="text-lg leading-relaxed text-ink-soft">
                            I&rsquo;m Sarah Gmyr, and I live in Arlington. I started my career as an elementary
                            school teacher in the US, the UK and Australia, and I&rsquo;ve spent 18 years in health
                            and public communications, including work with the US Military Health System.
                            I&rsquo;ve completed Otago Exercise Program leader training and am completing SAIL
                            leader training (October 2026) through the Northern Virginia Falls Prevention Alliance
                            at Marymount University.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <p className="mt-5 text-lg leading-relaxed text-ink-soft">
                            Fall Safe Ready brings my teaching and health backgrounds together. I&rsquo;m building
                            it with a judo instructor and input from health professionals, because everyone
                            deserves to know what to do when a fall happens, and to keep moving with confidence.
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}